import { render, staticRenderFns } from "./LocationType.vue?vue&type=template&id=ecb1ddb2&"
import script from "./LocationType.vue?vue&type=script&lang=js&"
export * from "./LocationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports